import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取字典配置
export const getdictList = params => {
    return get("/admin/config", params);
};
// 删除字典
export const deleteDict = params => {
    return del(`/admin/config/${params}`);
};
// 修改字典信息
export const editDict = params => {
    return put(`/admin/config/${params.id}`, params);
};
// 添加字典
export const addDict = params => {
    return post("/admin/config", params);
};


// WEBPACK FOOTER //
// ./src/api/dict.js